import React, { useState, useEffect, useCallback } from 'react';
import './AdminCursosMoodle.css';
import ModalContenidoCurso from './ModalContenidoCurso';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/cursos_admin.php';

/* ── Icons ── */
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUsers    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconEyeOff   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconFilter   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconStar     = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="13" height="13"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconCalendar = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><rect x="3" y="4" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2"/><path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconSpinner  = () => (<span className="acm-spinner"/>);
const IconExport   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconChevL    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevR    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const FORM_VACIO = {
  precio:'', precio_anterior:'', descripcion_web:'',
  visible_web:true, destacado:false, etiqueta:'', notas_admin:'',
  seccion:'normal',
  imagen_custom:'', descripcion_custom:'',
  titulo_custom:'', titulo_negrita:false, titulo_minusculas:false,
};
const POR_PAGINA_OPTS = [10, 15, 20, 30];

export default function AdminCursosMoodle() {
  const [cursos,     setCursos]    = useState([]);
  const [loading,    setLoading]   = useState(false);
  const [busqueda,   setBusqueda]  = useState('');
  const [filtroVis,  setFiltroVis] = useState('todos');
  const [filtroSec,  setFiltroSec] = useState('todos');

  const [toast,      setToast]     = useState(null);

  // Paginación
  const [pagina,    setPagina]    = useState(1);
  const [porPagina, setPorPagina] = useState(10);

  // Modal editar
  const [modalCurso, setModalCurso] = useState(null);
  const [modalTab,   setModalTab]   = useState('config'); // 'config' | 'contenido'
  const [form,       setForm]       = useState(FORM_VACIO);
  const [guardando,  setGuardando]  = useState(false);

  // Modal inscritos
  const [modalIns,  setModalIns]  = useState(null);
  const [inscritos, setInscritos] = useState([]);
  const [loadIns,   setLoadIns]   = useState(false);
  const [busIns,    setBusIns]    = useState('');

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3000); };

  /* Fetch */
  const fetchCursos = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=list`);
      const j = await r.json();
      if (j.success) setCursos(j.data || []);
      else showToast(j.message || 'Error cargando cursos', 'error');
    } catch(e) { showToast('Error de conexión con Moodle', 'error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchCursos(); }, [fetchCursos]);

  // Reset página al cambiar filtros o búsqueda
  useEffect(() => { setPagina(1); }, [busqueda, filtroVis, filtroSec, porPagina]);

  /* Filtrar */
  const q = busqueda.toLowerCase();
 
 
  const filtrados = cursos.filter(c => {
    const matchBus = !q || c.fullname?.toLowerCase().includes(q) || c.shortname?.toLowerCase().includes(q);
    const matchVis = filtroVis === 'todos'
      || (filtroVis === 'visibles' && c.visible_web)
      || (filtroVis === 'ocultos'  && !c.visible_web);
    const matchSec = filtroSec === 'todos' || (c.seccion || 'normal') === filtroSec;
    return matchBus && matchVis && matchSec;
  });


  /* Paginación */
  const totalPaginas = Math.max(1, Math.ceil(filtrados.length / porPagina));
  const paginaSegura = Math.min(pagina, totalPaginas);
  const inicio       = (paginaSegura - 1) * porPagina;
  const cursosPage   = filtrados.slice(inicio, inicio + porPagina);

  const paginasVisibles = () => {
    const pages = [];
    const delta = 2;
    for (let i = Math.max(1, paginaSegura - delta); i <= Math.min(totalPaginas, paginaSegura + delta); i++) {
      pages.push(i);
    }
    return pages;
  };

  /* KPIs */
  const totalInscritos = cursos.reduce((a,c)=>a+(c.total_inscritos||0),0);
  const visibles = cursos.filter(c=>c.visible_web).length;
  const ocultos  = cursos.filter(c=>!c.visible_web).length;

  /* Toggle visible */
  const toggleVisible = async (curso) => {
    const nuevoValor = !curso.visible_web;
    setCursos(cs => cs.map(c => c.id===curso.id ? {...c, visible_web: nuevoValor} : c));
    try {
      const r = await fetch(`${API}?action=toggle_visible`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ moodle_id: curso.id, visible_web: nuevoValor }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(nuevoValor ? 'Curso visible en el sitio' : 'Curso oculto del sitio');
    } catch(err) {
      setCursos(cs => cs.map(c => c.id===curso.id ? {...c, visible_web: !nuevoValor} : c));
      showToast(err.message, 'error');
    }
  };

  /* Abrir editar */
  const abrirEditar = (curso) => {
    setModalCurso(curso);
    setModalTab('config');
    setForm({
      precio:             curso.precio             ?? '',
      precio_anterior:    curso.precio_anterior    ?? '',
      descripcion_web:    curso.descripcion_web    ?? '',
      visible_web:        curso.visible_web        ?? true,
      destacado:          curso.destacado          ?? false,
      etiqueta:           curso.etiqueta           ?? '',
      notas_admin:        curso.notas_admin        ?? '',
      seccion:            curso.seccion            ?? 'normal',
      imagen_custom:      curso.imagen_custom      ?? '',
      descripcion_custom: curso.descripcion_custom ?? '',
      titulo_custom:      curso.titulo_custom      ?? '',
      titulo_negrita:     curso.titulo_negrita     ?? false,
      titulo_minusculas:  curso.titulo_minusculas  ?? false,
    });


  };

  /* Guardar config */
  const guardarConfig = async () => {
    if (!modalCurso) return;
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=guardar_config`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ moodle_id: modalCurso.id, ...form }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Configuración guardada');
      setModalCurso(null);
      fetchCursos();
    } catch(err) { showToast(err.message, 'error'); }
    finally { setGuardando(false); }
  };

  /* Ver inscritos */
  const verInscritos = async (curso) => {
    setModalIns(curso);
    setInscritos([]);
    setBusIns('');
    setLoadIns(true);
    try {
      const r = await fetch(`${API}?action=inscritos&id=${curso.id}`);
      const j = await r.json();
      if (j.success) setInscritos(j.data || []);
    } catch(e) {}
    finally { setLoadIns(false); }
  };

  /* Exportar CSV inscritos */
  const exportarInscritos = () => {
    const headers = ['Nombre','Email','Teléfono','País','Inscrito','Último acceso','Activo'];
    const rows = inscritosFiltrados.map(i => [
      i.nombre, i.email, i.telefono, i.pais,
      i.fecha_inscripcion, i.ultimo_acceso, i.activo?'Sí':'No'
    ]);
    const csv = [headers,...rows].map(r=>r.map(v=>`"${v}"`).join(',')).join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8;'}));
    a.download = `inscritos_${modalIns?.shortname||'curso'}_${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    showToast('CSV exportado');
  };

  const inscritosFiltrados = inscritos.filter(i =>
    !busIns || i.nombre.toLowerCase().includes(busIns.toLowerCase()) || i.email.toLowerCase().includes(busIns.toLowerCase())
  );

  return (
    <div className="acm-page">

      {toast && (
        <div className={`acm-toast acm-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* KPIs */}
      <div className="acm-kpis">
        <div className="acm-kpi acm-kpi--verde">
          <p>Cursos en Moodle</p>
          <strong>{loading?'…':cursos.length}</strong>
          <span>{visibles} visibles en el sitio</span>
        </div>
        <div className="acm-kpi">
          <p>Total inscritos</p>
          <strong>{loading?'…':totalInscritos.toLocaleString()}</strong>
          <span>en todos los cursos</span>
        </div>
        <div className="acm-kpi">
          <p>Visibles en web</p>
          <strong>{loading?'…':visibles}</strong>
          <span>aparecen en Formaciones</span>
        </div>
        <div className="acm-kpi acm-kpi--rojo">
          <p>Ocultos del sitio</p>
          <strong>{loading?'…':ocultos}</strong>
          <span>no aparecen públicamente</span>
        </div>
      </div>

      {/* Toolbar */}
      <div className="acm-toolbar">
        <div className="acm-search">
          <IconSearch/>
          <input type="text" placeholder="Buscar por título o código…"
            value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
          {busqueda && <button className="acm-search__clear" onClick={()=>setBusqueda('')}><IconClose/></button>}
        </div>
        <div className="acm-filtros">
          <IconFilter/>
          {[
            {id:'todos',    label:'Todos'},
            {id:'visibles', label:'Visibles'},
            {id:'ocultos',  label:'Ocultos'},
          ].map(f=>(
            <button key={f.id}
              className={`acm-filtro ${filtroVis===f.id?'acm-filtro--active':''}`}
              onClick={()=>setFiltroVis(f.id)}
            >{f.label}</button>
          ))}
        </div>

        {/* Por página */}
        <div className="acm-por-pagina">
          <span>Mostrar:</span>
          {POR_PAGINA_OPTS.map(n=>(
            <button key={n}
              className={`acm-pp-btn ${porPagina===n?'acm-pp-btn--active':''}`}
              onClick={()=>setPorPagina(n)}
            >{n}</button>
          ))}
        </div>

        <div className="acm-filtros" style={{marginLeft:0}}>
        {[
            {id:'todos',     label:'Todas'},
            {id:'normal',    label:'📚 Grabados'},
            {id:'asincrono', label:'🎧 Asincrónicos'},
            {id:'en_vivo',   label:'🔴 En vivo'},
            {id:'proximos',  label:'📅 Próximos'},
            {id:'gratuito',  label:'🎁 Gratuitos'},
          ].map(f=>(
            <button key={f.id}
              className={`acm-filtro ${filtroSec===f.id?'acm-filtro--active':''}`}
              onClick={()=>setFiltroSec(f.id)}
            >{f.label}</button>
          ))}
        </div>
        <button className="acm-btn-ghost" onClick={fetchCursos}><IconRefresh/> Sincronizar</button>
        <span className="acm-count">{filtrados.length} cursos</span>
      </div>

      {/* Tabla */}
      <div className="acm-tabla-wrap acm-card">
        <table className="acm-tabla">
          <thead>
          <tr>
              <th>Curso</th>
              <th>Código</th>
              <th>Categoría Moodle</th>
              <th>Sección</th>
              <th>Inscritos</th>
              <th>Precio web</th>
              <th>Etiqueta</th>
              <th>Visible en sitio</th>
              <th>Inicio</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
            <tr><td colSpan="10" className="acm-loading-row">
                <IconSpinner/> Cargando cursos desde Moodle…
              </td></tr>
            ) : cursosPage.length === 0 ? (
              <tr><td colSpan="10" className="acm-empty-row">
                {cursos.length===0 ? 'No se encontraron cursos en Moodle' : 'Sin resultados'}
              </td></tr>
            ) : cursosPage.map(c => (
              <tr key={c.id} className={`acm-tr ${!c.visible_web?'acm-tr--oculta':''}`}>

                <td>
                  <div className="acm-curso-info">
                    {c.imagen_url ? (
                      <img src={c.imagen_url} alt="" className="acm-thumb-img"/>
                    ) : (
                      <div className="acm-thumb-placeholder">📚</div>
                    )}
                    <div>
                      <strong>{c.fullname}</strong>
                      {c.summary_text && <span>{c.summary_text.slice(0,80)}{c.summary_text.length>80?'…':''}</span>}
                      {c.destacado && <span className="acm-dest-badge"><IconStar/> Destacado</span>}
                    </div>
                  </div>
                </td>

                <td><span className="acm-code">{c.shortname}</span></td>
              
                <td><span className="acm-cat" title="Categoría en Moodle (solo lectura)">{c.categoria_moodle || '—'}</span></td>

                <td>
  {(c.seccion||'normal') === 'en_vivo'
    ? <span className="acm-seccion acm-seccion--vivo">🔴 En vivo</span>
    : (c.seccion||'normal') === 'proximos'
    ? <span className="acm-seccion acm-seccion--prox">📅 Próximo</span>
    : (c.seccion||'normal') === 'asincrono'
    ? <span className="acm-seccion acm-seccion--asinc">🎧 Asincrónico</span>
    : (c.seccion||'normal') === 'gratuito'
    ? <span className="acm-seccion acm-seccion--gratis">🎁 Gratuito</span>
    : <span className="acm-seccion acm-seccion--normal">📚 Grabado</span>
  }
</td>

<td>
  <button className="acm-ins-btn" onClick={()=>verInscritos(c)}>



                    <IconUsers/> <strong>{c.total_inscritos}</strong>
                  </button>
                </td>

                <td>
                  {c.precio
                    ? <div className="acm-precio">
                        <strong>S/. {parseFloat(c.precio).toFixed(0)}</strong>
                        {c.precio_anterior && <span>S/. {parseFloat(c.precio_anterior).toFixed(0)}</span>}
                      </div>
                    : <span className="acm-nd">Sin precio</span>
                  }
                </td>

                <td>
                  {c.etiqueta
                    ? <span className="acm-etiqueta">{c.etiqueta}</span>
                    : <span className="acm-nd">—</span>
                  }
                </td>

                <td>
                  <button
                    className={`acm-toggle ${c.visible_web?'acm-toggle--on':'acm-toggle--off'}`}
                    onClick={()=>toggleVisible(c)}
                    title={c.visible_web?'Clic para ocultar':'Clic para mostrar'}
                  >
                    {c.visible_web ? <><IconEye/> Visible</> : <><IconEyeOff/> Oculto</>}
                  </button>
                </td>

                <td className="acm-fecha">
                  <IconCalendar/> {c.fecha_inicio}
                </td>

                <td>
                  <div className="acm-acciones">
                    <button className="acm-icon-btn acm-icon-btn--edit" onClick={()=>abrirEditar(c)} title="Editar"><IconEdit/></button>
                    <button className="acm-icon-btn acm-icon-btn--ins"  onClick={()=>verInscritos(c)} title="Ver inscritos"><IconUsers/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── PAGINACIÓN ── */}
      {!loading && filtrados.length > 0 && (
        <div className="acm-paginacion">
          <p className="acm-pag__info">
            Mostrando {inicio+1}–{Math.min(inicio+porPagina, filtrados.length)} de {filtrados.length} cursos
          </p>
          <div className="acm-pag__controles">
            <button className="acm-pag__btn" onClick={()=>setPagina(p=>Math.max(1,p-1))} disabled={paginaSegura===1}>
              <IconChevL/>
            </button>
            {paginasVisibles()[0] > 1 && (
              <><button className="acm-pag__num" onClick={()=>setPagina(1)}>1</button>
              {paginasVisibles()[0] > 2 && <span className="acm-pag__dots">…</span>}</>
            )}
            {paginasVisibles().map(p=>(
              <button key={p}
                className={`acm-pag__num ${p===paginaSegura?'acm-pag__num--active':''}`}
                onClick={()=>setPagina(p)}>{p}</button>
            ))}
            {paginasVisibles().at(-1) < totalPaginas && (
              <>{paginasVisibles().at(-1) < totalPaginas-1 && <span className="acm-pag__dots">…</span>}
              <button className="acm-pag__num" onClick={()=>setPagina(totalPaginas)}>{totalPaginas}</button></>
            )}
            <button className="acm-pag__btn" onClick={()=>setPagina(p=>Math.min(totalPaginas,p+1))} disabled={paginaSegura===totalPaginas}>
              <IconChevR/>
            </button>
          </div>
        </div>
      )}

      {/* ══ MODAL EDITAR CURSO — con tabs Config / Contenido ══ */}
      {modalCurso && (
        <div className="acm-overlay" onClick={()=>setModalCurso(null)}>
          <div className="acm-modal acm-modal--lg" onClick={e=>e.stopPropagation()}>

            {/* Head */}
            <div className="acm-modal__head">
              <div>
                <h2>Editar curso</h2>
                <p className="acm-modal__sub">{modalCurso.fullname}</p>
                <span className="acm-code">{modalCurso.shortname}</span>
              </div>
              <button className="acm-modal__close" onClick={()=>setModalCurso(null)}><IconClose/></button>
            </div>

            {/* Tabs del modal */}
            <div className="acm-modal__tabs">
              <button
                className={`acm-modal__tab ${modalTab==='config'?'acm-modal__tab--active':''}`}
                onClick={()=>setModalTab('config')}
              >⚙️ Configuración</button>
              <button
                className={`acm-modal__tab ${modalTab==='contenido'?'acm-modal__tab--active':''}`}
                onClick={()=>setModalTab('contenido')}
              >📄 Contenido del curso</button>
            </div>

            {/* ── Tab: Configuración ── */}
            {modalTab === 'config' && (
              <>
                <div className="acm-modal__body">
                  <div className="acm-form-grid">
                    <div className="acm-field">
                      <label>Precio en el sitio (S/.)</label>
                      <input type="number" step="0.01" placeholder="Ej: 180"
                        value={form.precio} onChange={e=>setForm(f=>({...f,precio:e.target.value}))}/>
                    </div>
                    <div className="acm-field">
                      <label>Precio anterior / tachado (S/.)</label>
                      <input type="number" step="0.01" placeholder="Ej: 220"
                        value={form.precio_anterior} onChange={e=>setForm(f=>({...f,precio_anterior:e.target.value}))}/>
                    </div>
                  
                  {/*   <div className="acm-field acm-field--full">
  <label>Descripción personalizada para el sitio</label>
  <textarea rows="3" placeholder="Si dejas vacío se usa la descripción de Moodle…"
    value={form.descripcion_web} onChange={e=>setForm(f=>({...f,descripcion_web:e.target.value}))}/>
</div>*/}

<div className="acm-field acm-field--full">
  <label>Título personalizado</label>
  <input type="text" placeholder={`Título actual: ${modalCurso.fullname}`}
    value={form.titulo_custom}
    onChange={e=>setForm(f=>({...f,titulo_custom:e.target.value}))}/>
  <span style={{fontSize:'.72rem',color:'#5a6a63',marginTop:'.3rem',display:'block'}}>
    Si lo dejas vacío se usa el título original de Moodle.
  </span>
  <div style={{display:'flex',gap:'1.5rem',marginTop:'.6rem'}}>
    <label className="acm-checkbox">
      <input type="checkbox" checked={!!form.titulo_negrita}
        onChange={e=>setForm(f=>({...f,titulo_negrita:e.target.checked}))}/>
      <span><strong>Negrita</strong></span>
    </label>
    <label className="acm-checkbox">
      <input type="checkbox" checked={!!form.titulo_minusculas}
        onChange={e=>setForm(f=>({...f,titulo_minusculas:e.target.checked}))}/>
      <span>Minúsculas (sin uppercase)</span>
    </label>
  </div>
  {/* Preview */}
  <div style={{marginTop:'.7rem',padding:'.6rem 1rem',background:'#f3f8f5',borderRadius:8,border:'1px solid rgba(130,216,179,.3)'}}>
    <span style={{fontSize:'.72rem',color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>Preview del título:</span>
    <span style={{
      fontWeight: form.titulo_negrita ? 700 : 300,
      textTransform: form.titulo_minusculas ? 'none' : 'uppercase',
      fontSize:'.95rem', color:'#1a2e28'
    }}>
      {form.titulo_custom || modalCurso.fullname}
    </span>
  </div>
</div>

<div className="acm-field acm-field--full">
  <label>Imagen personalizada</label>
  <div style={{display:'flex',alignItems:'center',gap:'1rem',flexWrap:'wrap'}}>
    {(form.imagen_custom) && (
      <img src={form.imagen_custom} alt="preview"
        style={{height:80,borderRadius:8,objectFit:'cover',border:'1.5px solid rgba(130,216,179,.3)'}}/>
    )}
    {!form.imagen_custom && modalCurso?.imagen_url && (
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'.3rem'}}>
        <img src={modalCurso.imagen_url} alt="Moodle"
          style={{height:80,borderRadius:8,objectFit:'cover',opacity:.5,border:'1.5px dashed #ccc'}}/>
        <span style={{fontSize:'.68rem',color:'#9ca3af'}}>Imagen actual de Moodle</span>
      </div>
    )}
    <div style={{display:'flex',flexDirection:'column',gap:'.4rem'}}>
      <label className="acm-upload-btn">
        📁 {form.imagen_custom ? 'Cambiar imagen' : 'Subir imagen'}
        <input type="file" accept="image/jpeg,image/png,image/webp" style={{display:'none'}}
          onChange={async (e) => {
            const file = e.target.files[0];
            if (!file) return;
            const fd = new FormData();
            fd.append('imagen', file);
            fd.append('moodle_id', modalCurso.id);
            try {
              const r = await fetch(`${API}?action=subir_imagen`, { method:'POST', body: fd });
              const j = await r.json();
              if (j.success) {
                setForm(f => ({...f, imagen_custom: j.data.imagen_custom}));
                showToast('Imagen subida correctamente');
              } else {
                showToast(j.message || 'Error al subir', 'error');
              }
            } catch {
              showToast('Error de conexión', 'error');
            }
          }}
        />
      </label>
      {form.imagen_custom && (
        <button className="acm-btn-ghost acm-btn-ghost--sm"
          style={{fontSize:'.72rem',color:'#dc2626',border:'1px solid #fecaca'}}
          onClick={() => setForm(f => ({...f, imagen_custom: ''}))}>
          🗑 Quitar imagen
        </button>
      )}
    </div>
  </div>
  <span style={{fontSize:'.72rem',color:'#5a6a63',marginTop:'.3rem',display:'block'}}>
    Reemplaza la imagen de Moodle en la card del sitio. JPG, PNG o WEBP, máx 10MB.
  </span>
</div>

<div className="acm-field acm-field--full">
  <label>Descripción personalizada para la card</label>
  <textarea rows="2" placeholder="Si dejas vacío se usa el texto de Moodle…"
    value={form.descripcion_custom}
    onChange={e=>setForm(f=>({...f,descripcion_custom:e.target.value}))}/>
</div>

<div className="acm-field">
  <label>Acceso / Etiqueta del curso</label>
  <input type="text" placeholder="Ej: ACCESO POR 14 DÍAS, ACCESO POR 6 MESES, ACCESO ILIMITADO…"
    value={form.etiqueta} onChange={e=>setForm(f=>({...f,etiqueta:e.target.value}))}/>
  <span style={{fontSize:'.72rem',color:'#5a6a63',marginTop:'.3rem',display:'block'}}>
    Este texto aparece como barra verde en la card del curso en el sitio web.
  </span>
</div>


                    <div className="acm-field acm-field--full">
                      <label>Notas internas (solo admin)</label>
                      <input type="text" placeholder="Notas privadas…"
                        value={form.notas_admin} onChange={e=>setForm(f=>({...f,notas_admin:e.target.value}))}/>
                    </div>
                    
                    
                    
                    <div className="acm-field acm-field--full acm-checks">
                      <label className="acm-checkbox">
                        <input type="checkbox" checked={!!form.visible_web}
                          onChange={e=>setForm(f=>({...f,visible_web:e.target.checked}))}/>
                        <span>Visible en el sitio web público</span>
                      </label>
                      <label className="acm-checkbox">
                        <input type="checkbox" checked={!!form.destacado}
                          onChange={e=>setForm(f=>({...f,destacado:e.target.checked}))}/>
                        <span>⭐ Marcar como destacado</span>
                      </label>
                    </div>

                    <div className="acm-field">
                      <label>Sección en Formaciones</label>
                      
                      <select
                        value={form.seccion || 'normal'}
                        onChange={e=>setForm(f=>({...f,seccion:e.target.value}))}
                        className="acm-select"
                      >
                        <option value="normal">📚 Grabado</option>
                        <option value="asincrono">🎧 Asincrónico</option>
                        <option value="en_vivo">🔴 En vivo</option>
                        <option value="proximos">📅 Próximo</option>
                        <option value="gratuito">🎁 Gratuito</option>
                      </select>




                      <span style={{fontSize:'.72rem',color:'#5a6a63',marginTop:'.3rem',display:'block'}}>
                        Define en qué sección aparece en la página de Formaciones
                      </span>
                    </div>


                  </div>
                  <div className="acm-moodle-info">
                    <p className="acm-moodle-info__label">Datos desde Moodle (solo lectura)</p>
                    <div className="acm-moodle-info__grid">
                      <div><span>Inscritos</span><strong>{modalCurso.total_inscritos}</strong></div>
                      <div><span>Inicio</span><strong>{modalCurso.fecha_inicio}</strong></div>
                      <div><span>Categoría</span><strong>{modalCurso.categoria_moodle||'—'}</strong></div>
                      <div><span>Visible Moodle</span><strong>{modalCurso.visible_moodle?'Sí':'No'}</strong></div>
                    </div>
                  </div>
                </div>
                <div className="acm-modal__foot">
                  <button className="acm-btn-ghost" onClick={()=>setModalCurso(null)}>Cancelar</button>
                  <button className="acm-btn-primary" onClick={guardarConfig} disabled={guardando}>
                    {guardando?<><IconSpinner/> Guardando…</>:<><IconCheck/> Guardar</>}
                  </button>
                </div>
              </>
            )}

            {/* ── Tab: Contenido ── */}
            {modalTab === 'contenido' && (
              <>
                <div className="acm-modal__body">
                  <ModalContenidoCurso
                    moodleId={modalCurso.id}
                    onToast={(msg, tipo='ok') => showToast(msg, tipo)}
                  />
                </div>
                <div className="acm-modal__foot">
                  <button className="acm-btn-ghost" onClick={()=>setModalCurso(null)}>Cerrar</button>
                </div>
              </>
            )}

          </div>
        </div>
      )}

      {/* ══ MODAL INSCRITOS ══ */}
      {modalIns && (
        <div className="acm-overlay" onClick={()=>setModalIns(null)}>
          <div className="acm-modal acm-modal--lg" onClick={e=>e.stopPropagation()}>
            <div className="acm-modal__head">
              <div>
                <h2>Inscritos en el curso</h2>
                <p className="acm-modal__sub">{modalIns.fullname}</p>
              </div>
              <button className="acm-modal__close" onClick={()=>setModalIns(null)}><IconClose/></button>
            </div>
            <div className="acm-modal__body">
              <div className="acm-ins-toolbar">
                <div className="acm-search acm-search--sm">
                  <IconSearch/>
                  <input type="text" placeholder="Buscar inscrito…"
                    value={busIns} onChange={e=>setBusIns(e.target.value)}/>
                </div>
                <span className="acm-count">{inscritosFiltrados.length} inscritos</span>
                {inscritos.length > 0 && (
                  <button className="acm-btn-ghost acm-btn-ghost--sm" onClick={exportarInscritos}>
                    <IconExport/> CSV
                  </button>
                )}
              </div>
              {loadIns ? (
                <div className="acm-loading-row"><IconSpinner/> Cargando inscritos…</div>
              ) : inscritosFiltrados.length === 0 ? (
                <div className="acm-empty-row">
                  {inscritos.length===0 ? 'Aún no hay inscritos en este curso' : 'Sin resultados'}
                </div>
              ) : (
                <div className="acm-ins-tabla-wrap">
                  <table className="acm-tabla acm-tabla--sm">
                    <thead>
                      <tr>
                        <th>Nombre</th><th>Email</th><th>Teléfono</th>
                        <th>Inscrito</th><th>Último acceso</th><th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inscritosFiltrados.map(i=>(
                        <tr key={i.id} className="acm-tr">
                          <td><div className="acm-ins-info"><div className="acm-avatar">{(i.nombre||'?')[0].toUpperCase()}</div><strong>{i.nombre}</strong></div></td>
                          <td><span className="acm-email">{i.email}</span></td>
                          <td><span className="acm-nd">{i.telefono}</span></td>
                          <td className="acm-fecha">{i.fecha_inscripcion}</td>
                          <td className="acm-fecha">{i.ultimo_acceso}</td>
                          <td><span className={`acm-estado ${i.activo?'acm-estado--activo':'acm-estado--inactivo'}`}>{i.activo?'Activo':'Inactivo'}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="acm-modal__foot">
              <button className="acm-btn-ghost" onClick={()=>setModalIns(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}